// database.js
import Dexie from "dexie";

const db = new Dexie("discoin");

// db.version(5).stores({
//   posts:
//     "[postId+locationKey], postId, locationKey, updatedAt, [locationKey+updatedAt]",
//   profiles: "businessId, updatedAt",
//   businessPosts: "postId, businessId, updatedAt, [businessId+updatedAt]",
//   categories: "id, updatedAt",
// });

db.version(7).stores({
  // ONE record per post
  posts: "postId, updatedAt",

  // MANY location keys → postId references
  //postIndexes: "[locationKey+postId], locationKey, postId, updatedAt",

  profiles: "businessId, updatedAt",
  businessPosts: "postId, businessId, updatedAt",
  categories: "id, updatedAt",
});

console.log("Local database initialized (Web)");

//};

// MAIN CATEGOIES
export const getCachedCategories = async () => {
  const entry = await db.categories.get("main");
  if (!entry) return null;

  const oneWeekAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
  const updatedAt = new Date(entry.updatedAt).getTime();

  return updatedAt >= oneWeekAgo ? JSON.parse(entry.data) : null;
};

export const cacheCategories = async (categories) => {
  const updatedAt = new Date().toISOString();
  await db.categories.put({
    id: "main",
    data: JSON.stringify(categories),
    updatedAt,
  });
};

// POSTS
export const insertOrUpdatePost = async (post) => {
  try {
    await db.posts.put({
      postId: post.postId,
      updatedAt: post.updatedAt || post.createdAt || new Date().toISOString(),
      data: JSON.stringify(post),
    });
  } catch (error) {
    console.error("Error saving post to cache:", error);
  }
};

export const getAllPosts = async () => {
  const rows = await db.posts.toArray();
  return rows.map((row) => JSON.parse(row.data));
};

export const getPostById = async (postId) => {
  const row = await db.posts.get(postId);
  return row ? JSON.parse(row.data) : null;
};

/* BUSINESS POSTS CACHE */
export const insertOrUpdateBusinessPost = async (post) => {
  try {
    await db.businessPosts.put({
      postId: post.postId,
      businessId: post.businessId,
      data: JSON.stringify(post),
      updatedAt: post.updatedAt || post.createdAt, // ✅ SERVER timestamp
      cachedAt: new Date().toISOString(), // optional but useful
    });
  } catch (error) {
    console.error("Error adding business post into local database:", error);
    throw error;
  }
};

export const getBusinessPostsByBusinessId = async (businessId) => {
  try {
    const rows = await db.businessPosts
      .where("businessId")
      .equals(businessId)
      .toArray();

    return rows.map((row) => JSON.parse(row.data));
  } catch (error) {
    console.error("Error fetching business posts from local database:", error);
    throw error;
  }
};

export const getAllBusinessPosts = async () => {
  const rows = await db.businessPosts.toArray();
  return rows.map((row) => JSON.parse(row.data));
};

export const getLastBusinessPostFetchDate = async (businessId) => {
  try {
    const lastPost = await db.businessPosts
      .where("businessId")
      .equals(businessId)
      .orderBy("updatedAt")
      .reverse()
      .first();

    return lastPost?.updatedAt || null;
  } catch (err) {
    // Happens when no records exist
    console.log("No cached business posts yet");
    return null;
  }
};

export const getBusinessPostById = async (postId) => {
  try {
    const row = await db.businessPosts.get(postId);
    if (!row) return null;
    return JSON.parse(row.data);
  } catch (error) {
    console.error(
      "Error fetching business post by id from local database:",
      error,
    );
    throw error;
  }
};

export const deleteBusinessPostById = async (postId) => {
  try {
    await db.businessPosts.delete(postId);
    console.log(`Post with ID ${postId} deleted from local IndexedDB.`);
  } catch (error) {
    console.error("Error deleting post from local database:", error);
    throw error;
  }
};

// PROFILES
// export const insertOrUpdateProfile = async (profile) => {
//   try {
//     const data = JSON.stringify(profile);
//     const updatedAt = new Date().toISOString();
//     await db.profiles.put({ businessId: profile.businessId, data, updatedAt });
//   } catch (error) {
//     console.error("Error adding profile into local database:", error);
//     throw error;
//   }
// };
export const insertOrUpdateProfile = async (profile) => {
  try {
    console.log("[PROFILE CACHE] profile:", profile);
    const data = JSON.stringify(profile);
    console.log("[PROFILE CACHE] data:", data);
    await db.profiles.put({
      businessId: profile.businessId,
      data,
      updatedAt: profile.updatedAt || new Date().toISOString(),
    });

    // DEBUG: immediately read it back
    const saved = await db.profiles.get(profile.businessId);

    console.log("[PROFILE CACHE] Saved record:", saved);
    console.log(
      "[PROFILE CACHE] Saved phone:",
      saved ? JSON.parse(saved.data).phone : null,
    );
    console.log(
      "[PROFILE CACHE] Saved whatsappPhone:",
      saved ? JSON.parse(saved.data).whatsappPhone : null,
    );
    console.log("[PROFILE CACHE] Saved updatedAt:", saved?.updatedAt);
  } catch (error) {
    console.error("Error adding profile into local database:", error);
    throw error;
  }
};

export const getAllProfiles = async () => {
  const rows = await db.profiles.toArray();
  return rows.map((row) => JSON.parse(row.data));
};

export const getProfileLastFetchDate = async () => {
  const lastProfile = await db.profiles.orderBy("updatedAt").last();
  return lastProfile?.updatedAt || null;
};

export const getProfileByBusinessId = async (businessId) => {
  try {
    const row = await db.profiles.get(businessId);
    if (!row) return null;
    return JSON.parse(row.data);
  } catch (error) {
    console.error("Error fetching profile by id from local database:", error);
    throw error;
  }
};

export default db;
